export const patchLocalStorage = (
  path: string,
  value: Record<string, string | number | object>
) => {
  const current = JSON.parse(localStorage.getItem(path) || '{}');
  localStorage.setItem(path, JSON.stringify({ ...current, ...value }));
};
